import { Table } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DATA_TABLE_UTIL } from "../../../../../utils/data-table.utils";
import { DATE_UTIL } from "../../../../../utils/dateUtils";
import UTIL from "../../../../../utils/utils";


interface Props {
    file?: File;
    data?: any[];
    loading?: boolean;
    columns?: any[];
}

const InputTable = (props: Props) => {

    const { t } = useTranslation();
    const [columns, setColumns] = useState<any[]>();

    useEffect(() => {
        setColumns(DATA_TABLE_UTIL.getColumnsTableData(props.data, undefined, props.columns));
    }, [props.data, props.columns])

    return (
        <div className="table-result-wrapper">

            {
                props.file && <div className="table-result-header">
                    <div>
                        <span style={{ marginRight: 5 }}>
                            {props.file?.name}
                        </span>
                        <span>
                            {t("RapmReport.lbCsvFile")} &middot; {UTIL.bytesToSize(props.file?.size)} &middot; {t("RapmReport.lbAddedOn")} {DATE_UTIL.CurrentDate()}
                        </span>
                    </div>
                </div>
            }

            <Table
                rowKey={"AccountNum"}
                loading={props.loading}
                columns={columns}
                pagination={false}
                dataSource={props.data}
                scroll={{ x: true }} />
        </div>
    )
}

export default InputTable;